// Define props interface (can be empty if no props needed)
export interface GuestReportComponentProps {
    // Add any props the component might need from Blazor here
}

// Export the mounting object
export const GuestReportComponent = {
    MountAsync: async (target: HTMLElement, props: GuestReportComponentProps) => {
        // Dynamically import the shared mounting helper and the actual component
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { GuestReportComponent } = await import('./GuestReportComponent');
        // Mount the component using the helper
        return await mountReactComponentAsync(target, GuestReportComponent, props);
    }
};